import { AlertCircle, Loader2 } from "lucide-react";

type Props =
  | { kind: "confirming"; total: number }
  | {
      kind: "error";
      message: string;
      retryable: boolean;
      onRetry: () => void;
      onCancel: () => void;
    };

export function ImportConfirmResult(props: Props) {
  if (props.kind === "confirming") {
    return (
      <output
        aria-live="polite"
        className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-app-border bg-app-surface px-6 py-12 text-app-ink-1"
        data-testid="import-confirming"
      >
        <Loader2 size={28} strokeWidth={2} className="animate-spin text-app-emerald" />
        <p className="font-medium">
          Importando {props.total} animal{props.total === 1 ? "" : "es"}…
        </p>
        <p className="text-app-ink-3 text-sm">No cierres esta pestaña.</p>
      </output>
    );
  }

  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-3 rounded-2xl border border-app-red bg-app-red-bg/40 px-4 py-4"
      data-testid="import-confirm-error"
    >
      <div className="flex items-center gap-2 text-app-red">
        <AlertCircle size={20} strokeWidth={2} />
        <p className="font-semibold">No pudimos completar el import</p>
      </div>
      <p className="text-app-ink-1 text-sm">{props.message}</p>
      <div className="flex gap-2">
        {props.retryable ? (
          <button
            type="button"
            onClick={props.onRetry}
            className="rounded-2xl bg-app-ink-1 px-4 py-2 font-medium text-[14px] text-white transition-colors hover:bg-[#1e211d]"
          >
            Reintentar
          </button>
        ) : null}
        <button
          type="button"
          onClick={props.onCancel}
          className="rounded-2xl border border-app-border bg-app-surface px-4 py-2 font-medium text-[14px] text-app-ink-1 transition-colors hover:bg-app-surface-2"
        >
          Volver al preview
        </button>
      </div>
    </div>
  );
}
